module.exports = __webpack_public_path__ + "img/logout.c778546.svg";